import { WithId } from "@rooted/shared";
import firebase from "firebase/app";

type Doc = firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>;
export default function toIdDoc<T>(document: Doc): WithId<T> {
  const data = document.data() as T;
  return Object.assign(data, { _id: document.id });
}
